import React, { useLayoutEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { useScrollReveal } from './useScrollReveal';
import { useCardSpotlight } from './useCardSpotlight';
import './taranaSite.css';

export function SiteLayout() {
  const location = useLocation();

  // Fade + slide-in sections as they scroll into view; re-observe on route change.
  useScrollReveal(location.pathname);
  // Cursor-following glow + tilt on dark surface cards.
  useCardSpotlight(location.pathname);

  // Reset scroll to top on route change *before* the browser paints the new
  // page, so it appears at the top instantly instead of rendering at the old
  // scroll position and then visibly jumping up. useLayoutEffect runs
  // synchronously after DOM mutations but before paint; 'instant' avoids any
  // smooth-scroll animation.
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [location.pathname]);

  return (
    <div className="tarana-site">
      <Navbar />
      <main className="t-page">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
